import { render, staticRenderFns } from "./MessageFormDrawer.vue?vue&type=template&id=085f8012&"
import script from "./MessageFormDrawer.vue?vue&type=script&lang=js&"
export * from "./MessageFormDrawer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports